import {
  ChangeDetectionStrategy,
  Component,
  inject,
  computed,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'

import { Enums, Hunt } from '@cyborg-monorepo/hunter/common'
import { SelectComponent, SelectOption, TypographyComponent } from '@hyperkit'

import {
  HuntViewService,
  HuntEditorService,
  SessionService,
} from '@hunt/services'

import { HuntEditorComponent } from '../../details/components/hunt-editor'

@Component({
  standalone: true,
  selector: 'edit-report-conclusion',
  imports: [
    RouterModule,
    FormsModule,
    SelectComponent,
    TypographyComponent,
    HuntEditorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './edit-report-conclusion.component.html',
  styleUrls: ['edit-report-conclusion.component.scss'],
})
export class EditReportConclusionComponent {
  public readonly huntView = inject(HuntViewService)
  public readonly huntEditor = inject(HuntEditorService)
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )

  /** All possible outcome values */
  public readonly outcomeValues: Enums.OutcomeEnum[] = Object.values(
    Enums.OutcomeEnum,
  )

  /**
   * Local model for the select.
   * Initialized from the current hunt’s outcome.
   */
  public outcome: Enums.OutcomeEnum =
    this.huntView.outcome() as Enums.OutcomeEnum

  /**
   * Handle a user changing the outcome dropdown.
   * Update via the editor service, then persist the draft.
   */
  public async onSelectionChange(
    option: SelectOption | string | number,
  ): Promise<void> {
    const newOutcome = option as Enums.OutcomeEnum
    await this.huntEditor.updateOutcome(newOutcome)

    // keep the select in sync
    this.outcome = newOutcome
  }
}
